<template>
  <div id="OrderPage">
    <template v-if="order_data != null">
      <div class="CheckOutForm">
        <div class="row">
          <div class="header">
            <router-link to="/">
              <img src="/img/logo.svg" />
            </router-link>
          </div>

          <div class="form Order active">
            <div
              class="title_box"
              v-if="this.order_data.EC_return_msg != '付款失敗'"
            >
              <i class="far fa-check-circle"></i>
              <div class="content">
                <p>訂單編號 #{{ this.order_data.order_id }}</p>
                <h3>{{ this.order_data.status | status }}</h3>
              </div>
            </div>

            <div class="title_box" v-else>
              <i class="far fa-check-circle"></i>
              <div class="content">
                <p>訂單建立失敗</p>
                <h3>發生錯誤</h3>
              </div>
            </div>

            <div
              class="content_box"
              v-if="this.order_data.EC_return_msg != '付款失敗'"
            >
              <h3>您的訂單已確認</h3>
              <p>您會在訂單準備就緒後收到電子郵件</p>
            </div>

            <div class="content_box" v-else>
              <h3>您的訂單未成功建立</h3>
              <p>請確認您的付款方式正確後重新下單</p>
            </div>

            <div class="user_data_content">
              <h3>客戶資料</h3>
              <div class="content_box">
                <div class="user_data">
                  <h4>聯絡資訊</h4>
                  <p>{{ this.order_data.name }}</p>
                  <p>{{ this.order_data.phone }}</p>
                  <p>{{ this.order_data.email }}</p>
                  <h4>備註</h4>
                  <p>{{ this.order_data.comment }}</p>
                  <h4>訂單狀態</h4>
                  <p>{{ this.order_data.ec_pay.return_msg }}</p>
                </div>
                <div class="user_payway">
                  <h4>付款方式</h4>
                  <p>
                    {{ this.order_data.payment | payment }}
                    <span
                      >-${{ this.order_data.total_price | priceFormat }}</span
                    >
                  </p>
                  <h4>配送地址</h4>
                  <div>
                    <p>{{ this.order_data.name }}</p>
                    <p>{{ this.order_data.address }}</p>
                    <p>{{ this.order_data.phone }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="form_footer">
              <button @click="GoHome">繼續購物</button>
            </div>
          </div>
        </div>
      </div>
      <div class="CheckOutShopCart">
        <div
          class="shop_cart_header"
          @click="show_shopcart_list = !show_shopcart_list"
        >
          <div class="header_row">
            <a v-show="!show_shopcart_list">
              <i class="fas fa-shopping-cart"></i>顯示訂單詳細
              <i class="fas fa-chevron-down"></i>
            </a>
            <a v-show="show_shopcart_list">
              <i class="fas fa-shopping-cart"></i>隱藏訂單詳細
              <i class="fas fa-chevron-up"></i>
            </a>
            <p>${{ this.order_data.total_price | priceFormat }}</p>
          </div>
        </div>

        <div class="row" :class="{ active: show_shopcart_list }">
          <ol class="shop_cart_list">
            <li
              v-for="(item, item_index) in order_data.products"
              :key="'shopcart_' + item_index"
              class="cart_item"
            >
              <!-- <img alt="Rerace 銳仕技研" :src="item.image" /> -->
              <div class="content">
                <p class="title">{{ item.name }}</p>
                <span class="option"
                  >{{ GetOptions(item.options) }} x{{ item.amount }}</span
                >
              </div>
              <span class="price"
                >NT${{ (item.price * item.amount) | priceFormat }}</span
              >
            </li>
          </ol>

          <hr />

          <div class="shop_cart_total">
            <p>運費</p>
            <h3>
              <span>TWD</span>
              ${{ this.order_data.shipping_fee | priceFormat }}
            </h3>
          </div>

          <div class="shop_cart_total">
            <p>總計</p>
            <h3>
              <span>TWD</span>
              ${{ this.order_data.total_price | priceFormat }}
            </h3>
          </div>
        </div>
      </div>
      <div class="header">
        <router-link to="/">
          <img src="/img/logo.svg" />
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "Checkout",
  data() {
    return {
      show_shopcart_list: false,
      order_data: null,
    };
  },
  methods: {
    GoHome() {
      this.$router.push("/");
    },
    async GetOrderData(order_data) {
      let result = await this.SendPostData(
        process.env.VUE_APP_BASE_API + "orders/get_order.php",
        qs.stringify(JSON.parse(order_data))
      );
      if (result != "error") {
        this.order_data = JSON.parse(result.data);
        this.$cookie.delete("order_data");
      }
    },
    GetOptions(options) {
      let string = "";
      options.split(",").forEach((item, item_index) => {
        string += item;
        item_index == options.split(",").length - 1 ? "" : (string += " - ");
      });
      return string;
    },
  },
  mounted() {
    if (this.$cookie.get("order_data")) {
      this.GetOrderData(this.$cookie.get("order_data"));
    } else {
      this.$router.push("/search_order");
    }
  },

  filters: {
    priceFormat(val) {
      // 加上千分位符號
      if (val) {
        return val
          .toString()
          .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function(
            all,
            pre,
            groupOf3Digital
          ) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          });
      } else {
        return 0;
      }
    },
    payment(val) {
      if (val == "Credit") {
        return "信用卡付款";
      } else if (val == "COD") {
        return "貨到付款";
      } else if (val == "CVS") {
        return "超商代碼繳費";
      } else if (val == "ATM") {
        return "ATM匯款";
      } else if (val == "WebATM") {
        return "WebATM匯款";
      } else if (val == "BARCODE") {
        return "超商條碼繳費";
      } else if (val == "C2C") {
        return "超商取貨付款";
      }
    },
    status(val) {
      if (val == "W") {
        return "等待付款中";
      } else if (val == "P") {
        return "已完成付款，等待出貨中";
      } else if (val == "S") {
        return "已出貨";
      } else if (val == "Y") {
        return "已完成";
      } else if (val == "N") {
        return "已取消";
      }
    },
  },

  metaInfo() {
    return {
      title: "訂單查詢｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content: "有任何訂單相關的疑問歡迎來電來訊與我們聯絡",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content: "有任何訂單相關的疑問歡迎來電來訊與我們聯絡",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content: "有任何訂單相關的疑問歡迎來電來訊與我們聯絡",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "訂單查詢｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "訂單查詢｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "訂單查詢｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
